'use strict';
module.exports = function parseAlgoliaClientVersion(agent) {
  var parsed = agent.match(/Algolia for vanilla JavaScript (\d+\.)(\d+\.)(\d+)/);
  if (parsed) return [parsed[1], parsed[2], parsed[3]];
  return undefined;
};



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/src/common/parseAlgoliaClientVersion.js
// module id = 473
// module chunks = 1